<template>
  <div>
    <DeleteModal modal-id="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      id="modal-radiology-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="createMode ? 'Add Patient  Test' : 'Edit Patient Card Radiology'"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <AutoComplete
              v-model="EditForm.tests"
              label="Test Group"
              placeholder="Select A Group"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="group"
              text-title="name"
              @input="selectGroup"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="">
            <AutoComplete
              v-model="EditForm.patient_card_id"
              label="Tests"
              placeholder="Select Patient"
              :multiple="true"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient_case"
            /> </b-col
        ></b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("lab.Main Tests") }}</h2>
        </div>

        <!-- Filters -->
        <b-row class="mb-3">
          <b-col md="5" cols="12">
            <b-form-group label-for="patient-filter">
              <AutoComplete
                id="patient-filter"
                v-model="selectedPatient"
                :label="$t('common.patient')"
                param-query="search"
                :serializer="(val) => val.id"
                endpoint="patient"
                text-title="name"
                @input="onFilterChange"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.date')" label-for="filter-date">
              <b-form-input
                id="filter-date"
                v-model="filterDate"
                type="date"
                :placeholder="$t('common.date')"
                @input="onFilterChange"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12" class="d-flex align-items-end">
            <b-button
              variant="outline-secondary"
              block
              :title="$t('common.clear')"
              @click="clearFilters"
            >
              <i class="fas fa-times-circle" />
            </b-button>
          </b-col>
        </b-row>

        <b-table
          v-if="!loading"
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
        >
          <template #cell(companion_phone)="data">
            <span
              style="unicode-bidi: isolate"
              :style="{
                direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
              }"
              >{{ data.item.companion_phone }}</span
            >
          </template>
          <!-- Column: Actions -->
          <template #cell(patient_name)="data">
            <div v-if="data.item.patient">
              {{ data.item.patient.name }}
            </div>
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-75 bgcolor"
                @click="
                  $router.push({
                    name: 'patients-tests-details',
                    params: { id: data.item.id },
                  })
                "
              >
                {{ $t("common.preview") }}</b-button
              >
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Showing 1 to 10 Patient Cards Radiologies</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="index()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
    vSelect,
  },
  // props: ["patientCardId"],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      patientCard: "",
      selectedPatient: null,
      filterDate: "",
      typeList: [
        {
          text: "Type 1",
          value: "0",
        },
        {
          text: "Type 2",
          value: "1",
        },
      ],
      dataCount: 0,
      data: [],
      EditForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "patient_name", label: this.$t("common.name"), sortable: true },
        {
          key: "full_companion_name",
          sortable: true,
          label: this.$t("reception.companion-name"),
        },
        {
          key: "companion_phone",
          sortable: true,
          label: this.$t("reception.companion-phone"),
        },

        { key: "out_date_time", sortable: true, label: this.$t("common.type") },

        { key: "type", sortable: true, label: this.$t("common.type") },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  watch: {
    page() {
      this.getPatientsRadiologies();
    },
  },
  mounted() {
    this.getPatientsRadiologies();
  },

  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          type: "",
          url: "",
          patient_card_id: item.patient_card_id,
          radiology_id: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.url = item.url;
        this.EditForm.patient_card_id = item.patient_card_id;
        this.EditForm.radiology_id = item.radiology_id;
        this.EditForm.type = item.type.toString();

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-radiology-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getPatientsRadiologies() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patient/test?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.patientCard) {
        url += `&filter[patient_card_id]=${this.patientCard}`;
      }

      // Filter by patient
      if (this.selectedPatient) {
        const patientId =
          typeof this.selectedPatient === "object"
            ? this.selectedPatient.id
            : this.selectedPatient;
        url += `&filter[patient_id]=${patientId}`;
      }

      // Filter by date (using created_at)
      if (this.filterDate) {
        url += `&filter[created_at]=${this.filterDate}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
    onFilterChange() {
      // Reset to first page when filters change
      this.page = 1;
      this.getPatientsRadiologies();
    },
    clearFilters() {
      this.selectedPatient = null;
      this.filterDate = "";
      this.page = 1;
      this.getPatientsRadiologies();
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/patientCardRadiology/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientsRadiologies();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: `deleted ${this.deleteForm.first_name} successfully`,
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: `Error deleting ${this.deleteForm.first_name}`,
            },
          });
        });
    },
    submitItem() {
      for (const item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = "/patientCardTest"),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Patient Card Test Added",
                  variant: "success",
                },
              });
              this.getPatientsRadiologies();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (const item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardRadiology/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientsRadiologies(this.patientCard);
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (const item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
